import { Text } from '@signifyd/legacy-components'
import { Select } from 'antd'
import { FC } from 'react'
import useGetTeamsById from 'core/queries/useGetTeamsById'
import './styles.less'
import TeamSelectHandler from './TeamSelectHandler'

export type SelectType = 'single' | 'multi'

interface Props {
  selectedIds: Array<number>
  onSave: (selectedIds: Array<string>) => void
  type: SelectType
}

const TeamSelect: FC<Props> = ({ onSave, selectedIds, type }) => {
  const { data: teams, error, isLoading } = useGetTeamsById(selectedIds)

  if (error) {
    return <Text block>An error occurred fetching your data</Text>
  }

  if (isLoading) {
    return <Select loading disabled className="teamSelect" />
  }

  if (!teams) {
    return <Text block>No teams found</Text>
  }

  return (
    <TeamSelectHandler
      initialSelectedEntities={teams}
      onSave={onSave}
      type={type}
    />
  )
}

export default TeamSelect
